<!-- Added by Amisha on 07/16/2026 to keep the contractor registration table markup in the all-contractors child view. -->
<div
  class="all-contractor-main-container"
  [class.overlay-active]="context.applicationViewType === 'overlay'"
>
  <div class="new-application-overlay" [style.display]="context.applicationViewType === 'overlay' ? null : 'none'">
    <router-outlet></router-outlet>
  </div>

  <wm-common-table
    #registrationTable
    tableType="Staff"
    [columns]="columns"
    [data]="parent.registrations"
    [isLoading]="parent.isLoading"
    [serverSidePagination]="true"
    [fixedPagination]="context.applicationViewType === 'overlay' ? false : true"
    [enableTableScroll]="
      context.applicationViewType === 'overlay' ? false : true
    "
    [currentPage]="parent.currentPage"
    [totalPages]="parent.totalPages"
    [pageSize]="parent.pageSize"
    [showRowsPerPage]="true"
    [showTotalRecords]="true"
    [totalRecords]="parent.totalRecords"
    [pageSizeStorageKey]="'contractors-janus'"
    [sortField]="parent.sortField"
    [sortDescending]="parent.sortDescending"
    [maxVisibleColumns]="7"
    [maxVisibleColumnsMessage]="'You can only show 7 columns at once.'"
    expansionMode="inline"
    expandOn="cell"
    [expandedComponent]="expandedComponent"
    [expandedComponentInputs]="expandedComponentInputs"
    (pageChange)="parent.onRegistrationPageChange($event)"
    (rowsPerPageChange)="parent.onRegistrationRowsPerPageChange($event)"
    (sortChanged)="parent.onRegistrationSortChanged($event)"
    (visibleColumnLimitReached)="onVisibleColumnLimitReached($event)"
    (displayedColumnsChange)="parent.onRegistrationColumnsChanged($event)"
    (exportColumnsChange)="parent.onRegistrationExportColumnsChanged($event)"
  >
  </wm-common-table>
</div>

<wm-common-confirmation-modal
  [data]="parent.modalData"
  (onYesClick)="parent.confirmAction()"
  (onNoClick)="parent.cancelAction()"
  (onOkClick)="parent.closeModal()"
  (onCloseClick)="parent.closeModal()"
  [isApplicantMobileview]="true"
>
</wm-common-confirmation-modal>

<wm-common-confirmation-modal
  [data]="columnLimitModalData"
  (onOkClick)="columnLimitModalData.open = false"
>
</wm-common-confirmation-modal>
